var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('h1',[_vm._v("Vue list app")]),_c('Synths',{attrs:{"synths":_vm.synths,"onSelect":_vm.handleSelect}}),_c('Detail',{attrs:{"synth":_vm.selected}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }